module.exports = __webpack_public_path__ + "img/sc.947cf9c5.jpg";